var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"text-align":"center"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])}
var staticRenderFns = []

export { render, staticRenderFns }